import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryTabs() {
  const [activeCategory, setActiveCategory] = useState('movie');

  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10" aria-label="影视分类">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">浏览分类</h2>
          <Link
            to={`/category/${activeCategory}`}
            className="text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex items-center gap-2 mb-6 flex-wrap">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex items-center gap-1.5 ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 rounded-xl p-4 md:p-5 flex flex-col items-center gap-2 transition-all hover:bg-primary-50 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-500">海量资源</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}